import React from 'react'
import { BsWhatsapp } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import FAQImage from "../../assets/aboutpage/faq.png"
import FaqSection from '../../components/AboutComponents/FaqSection/FaqSection'
import Banner from '../../components/Banner/Banner'
import BannerBar from '../../components/BannerBar/BannerBar'
import Footer from '../../components/Footer/Footer'
import Navbar from '../../components/Navbar/Navbar'
import TopBar from '../../components/TopBar/TopBar'

const FAQ = () => {
  return (
    <div>
        
        <Banner title="About Us" subtitle="FAQs" image={FAQImage} />
        <BannerBar />
        <FaqSection />
         
        <Footer />
    </div>
  )
}

export default FAQ